import { Router } from '@angular/router';
import { LoginService } from './../services/login/login.service';
import { ResponseValidator } from './../utils/response-validator';
import { queryParamToObject } from './../utils/util';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/login/login.service";
export class AuthGuard {
    constructor(router, auth) {
        this.router = router;
        this.auth = auth;
    }
    canActivate(next, state) {
        if (this.auth.userData.authenticated || this.auth.checkAuthSession(true)) {
            if (this.auth.userData.careGivees && this.auth.userData.careGivees.length && !this.auth.activeMember) {
                return this.router.navigateByUrl('/select-user', {
                    queryParams: queryParamToObject(),
                    queryParamsHandling: 'merge'
                });
            }
            if (this.auth.activeMember) {
                Object.assign(this.auth.userData, {
                    data: this.auth.activeMember,
                    caregivee: this.auth.activeMember.type === 'caregivee'
                });
            }
            return true;
        }
        const availableAuth = this.auth.authenticateCookie();
        return availableAuth.subscribe(response => {
            if (new ResponseValidator(response, true).status) {
                if (!this.auth.processAuthResp(response.response.detail)) {
                    this.auth.requestAuth(this.router, state);
                    return false;
                }
                const url = state.url === '/' || state.url === '' ? '/' : state.url;
                return this.router.navigateByUrl(url);
            }
            else {
                this.auth.requestAuth(this.router, state);
                return false;
            }
        }, err => {
        });
    }
}
AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.LoginService)); }, token: AuthGuard, providedIn: "root" });
